/**
 * Internationalizing files in po format (https://en.wikipedia.org/wiki/Gettext#Translating)
 * You can always add additional strings by adding your own po file. All po files are
 * combined to one JSON file per language and are loaded if the specific language is needed.
 */
import { fr_00707 } from '@assets/translations/locales/cu-00707';
import './assets/translations/locales/en.po';
import './assets/translations/locales/es.po';
import './assets/translations/locales/fr.po';
import './assets/translations/locales/pt.po';
import './assets/translations/locales/zh.po';

/**
 * Cette variable contient la liste des traductions spécifiques mises en place pour chaque client
 * Format : 
 * customTranslations = {
 *    '<code client>':{
 *       '<locale standard>': <variable correspondante dans le fichier dédié au client> // dans assets/translations/locales/*.ts
 *    }
 * }
 */
export const customTranslations = {
  '00707': {
    'fr': fr_00707
  }
};